import type { SVGProps } from 'react';

interface CrownIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const CrownIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & CrownIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 20 21"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="m15.775 14.174-.435 2.25H4.839l-.436-2.25zM18 7.752a.597.597 0 0 1-.72.584l-1.327 5.571H4.349L2.912 8.42a.597.597 0 1 1 .298-.173l2.3 2.179.5-3.632a.595.595 0 0 1 .08-1.185.597.597 0 0 1 .318 1.1l1.857 2.847 1.676-4.254a.596.596 0 1 1 .41.006l1.685 4.538 1.612-2.976a.594.594 0 0 1 .264-1.128.597.597 0 0 1 .125 1.179l.755 3.65 2.235-2.359a.593.593 0 0 1 .376-1.056c.33 0 .597.267.597.596m-4.364 1.673c-.073 1.773-.132 1.832-1.905 1.906 1.773.073 1.832.133 1.905 1.905.074-1.773.133-1.832 1.906-1.905-1.773-.073-1.832-.133-1.906-1.906m1.282 2.343c-.033.786-.06.812-.845.844.786.033.812.06.845.845.032-.786.059-.812.845-.845-.787-.032-.813-.058-.845-.844"
      fill="#F8F8F8"
    />
  </svg>
);
